import api from '../api';

// Mocks
// import { mockTableFilters, mockTableFiltersSelectClass } from '../../mocks/mock-table-filters';

/**
 * Get manager table filters
 * @param {string} path - The path of the page
 * @param {string | null} [contexte] - The context (optional)
 * @returns {Promise<ApiManagerTableFilters>} The manager table filters
 */
export const getTableFilters = async (path, contexte = null) => {
  // eslint-disable-next-line no-console
  console.log('path', path);
  const contexteParam = contexte ? `&contexte=${contexte}` : '';
  const response = await api.get(`/table-filters?path=${path}${contexteParam}`);
  return response.data;
  // return mockTableFilters;
};

/**
 * Post manager table filters
 * @param {string} path - The path of the page
 * @param {ApiManagerTableFiltersCreate} data - The table filters data
 * @param {string | null} [contexte] - The context (optional)
 * @returns {Promise<ApiManagerTableFiltersCreate>} The created table filters
 */
export const postTableFilters = async (path, data, contexte = null) => {
  // Normalize selectedOption: convert empty string to null (API requires string >= 1 char or null)
  const normalizedData = {
    ...data,
    personalViews: data?.personalViews ? {
      ...data.personalViews,
      selectedOption: data.personalViews.selectedOption === '' ? null : data.personalViews.selectedOption,
    } : data.personalViews,
  };
  const contexteParam = contexte ? `&contexte=${contexte}` : '';
  const response = await api.post(`/table-filters?path=${path}${contexteParam}`, normalizedData);
  return response.data;
  // return mockTableFilters;
};

/**
 * Get select options
 * @param {string} url - The url to fetch the select options
 * @returns {Promise<ApiManagerTableSelectOptionsOption[]>} The select options array
 */
export const getSelectOptions = async (url) => {
  // eslint-disable-next-line no-console
  console.log('url', url);
  // await new Promise((resolve) => {
  //   setTimeout(resolve, 1000);
  // });
  const response = await api.get(url);
  // L'API retourne maintenant { options: [...] } au lieu d'un array direct
  return response.data.options;
  // return mockTableFiltersSelectClass;
};
